// Module
var code = `<section class="page-body default-content">

  <h2>Buttons</h2>
  <p>
    Buttons are a core part of the SpyneJS design system. They provide consistent styles
    for primary actions, secondary actions, and contextual states like success or danger.
    Buttons come in multiple sizes and styles, and can include icons for clarity.
  </p>

  <!-- Variants -->
  <h3>Variants</h3>
  <p>Use variants to indicate purpose. The most common are <strong>Primary</strong> and <strong>Secondary</strong>, with semantic options for <strong>Success</strong>, <strong>Warning</strong>, <strong>Danger</strong>, and <strong>Info</strong>.</p>
  <div class="button-examples">
    <button class="btn btn-primary">Primary</button>
    <button class="btn btn-secondary">Secondary</button>
    <button class="btn btn-success">Success</button>
    <button class="btn btn-warning">Warning</button>
    <button class="btn btn-danger">Danger</button>
    <button class="btn btn-info">Info</button>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;button class="btn btn-primary"&gt;Primary&lt;/button&gt;
&lt;button class="btn btn-secondary"&gt;Secondary&lt;/button&gt;
&lt;button class="btn btn-success"&gt;Success&lt;/button&gt;
&lt;button class="btn btn-warning"&gt;Warning&lt;/button&gt;
&lt;button class="btn btn-danger"&gt;Danger&lt;/button&gt;
&lt;button class="btn btn-info"&gt;Info&lt;/button&gt;
    </code></pre>
  </div>

  <!-- Styles -->
  <h3>Styles</h3>
  <p>Buttons can be filled (default), outlined, or plain (minimal emphasis).</p>
  <div class="button-examples">
    <button class="btn btn-primary">Filled</button>
    <button class="btn btn-outline-primary">Outline</button>
    <button class="btn btn-plain-primary">Plain</button>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;button class="btn btn-primary"&gt;Filled&lt;/button&gt;
&lt;button class="btn btn-outline-primary"&gt;Outline&lt;/button&gt;
&lt;button class="btn btn-plain-primary"&gt;Plain&lt;/button&gt;
    </code></pre>
  </div>

  <!-- Sizes -->
  <h3>Sizes</h3>
  <p>Use size modifiers for small, medium (default), or large buttons.</p>
  <div class="button-examples">
    <button class="btn btn-primary btn-sm">Small</button>
    <button class="btn btn-primary">Medium</button>
    <button class="btn btn-primary btn-lg">Large</button>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;button class="btn btn-primary btn-sm"&gt;Small&lt;/button&gt;
&lt;button class="btn btn-primary"&gt;Medium&lt;/button&gt;
&lt;button class="btn btn-primary btn-lg"&gt;Large&lt;/button&gt;
    </code></pre>
  </div>

  <!-- With Icons -->
  <h3>With Icons</h3>
  <p>Use FontAwesome icons at the start or end of a button. Icons should be 16–20px for best alignment.</p>

  <!-- Live Examples -->
  <div class="button-examples">
    <button class="btn btn-primary">
      <i class="fa-solid fa-plus"></i> Add Item
    </button>

    <button class="btn btn-secondary">
      Next <i class="fa-solid fa-arrow-right"></i>
    </button>

    <button class="btn btn-icon-only" aria-label="Search">
      <i class="fa-solid fa-search"></i>
    </button>
  </div>

  <!-- Code Snippet -->
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;button class="btn btn-primary"&gt;
  &lt;i class="fa-solid fa-plus"&gt;&lt;/i&gt; Add Item
&lt;/button&gt;

&lt;button class="btn btn-secondary"&gt;
  Next &lt;i class="fa-solid fa-arrow-right"&gt;&lt;/i&gt;
&lt;/button&gt;

&lt;button class="btn btn-icon-only" aria-label="Search"&gt;
  &lt;i class="fa-solid fa-search"&gt;&lt;/i&gt;
&lt;/button&gt;
    </code></pre>
  </div>

  <!-- States -->
  <h3>States</h3>
  <p>Buttons have built-in states for hover, focus, disabled, and loading.</p>
  <div class="button-examples">
    <button class="btn btn-primary">Default</button>
    <button class="btn btn-primary" disabled>Disabled</button>
    <button class="btn btn-primary btn-loading">
      <span class="spinner"></span> Loading
    </button>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;button class="btn btn-primary"&gt;Default&lt;/button&gt;

&lt;button class="btn btn-primary" disabled&gt;Disabled&lt;/button&gt;

&lt;button class="btn btn-primary btn-loading"&gt;
  &lt;span class="spinner"&gt;&lt;/span&gt; Loading
&lt;/button&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Ensure button text has sufficient contrast with its background.</li>
    <li>Use <code>aria-disabled="true"</code> for disabled link-style buttons.</li>
    <li>Provide <code>aria-label</code> for icon-only buttons.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;